const s = (o, r) => {
  const t = r.toLowerCase();
  return o.filter((e) => [e.name, e.value, ...e.label ? [e.label.toString()] : []].some((n) => n.toLowerCase().includes(t)));
}, a = ({
  sections: o,
  searchValue: r,
  ignoreSearchFilter: t
}) => !r || t ? o : o.reduce((e, l) => {
  const n = s(l.options, r);
  return n.length !== 0 && e.push({
    label: l.label,
    options: n,
    color: l.color
  }), e;
}, []), u = (o, r) => o.filter((t) => t.value !== r.value), i = (o, r, t, e) => {
  const l = o.some((n) => n.options && n.options.length > 0);
  return !!r && (l || !!t || !!e);
};
export {
  s as filterOptions,
  a as getSections,
  u as removeOption,
  i as shouldDisplayMenu
};
